import React, { useState } from "react";
import PropTypes from "prop-types";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import { Input } from "@mui/material";
import { RHFTextField } from "../hook-form";
import TextField from "@mui/material/TextField";
const ConfirmDialog = (props) => {
  const {
    open,
    title,
    content,
    rejeicao,
    handleClose,
    cancelButtonTitle,
    confirmButtonTitle,
    onConfirm,
    rejeicaoEst,
    inativacao
  } = props;

  const [selectedReason, setSelectedReason] = useState("");
  const [motive, setMotive] = React.useState("");
  const [motiveError, setMotiveError] = React.useState("");
  const handleSelectChange = (event) => {
    setSelectedReason(event.target.value);
  };

  const handleConfirmClick = () => {
    if (rejeicao) {
      if(selectedReason != ""){
        setMotiveError(false)
        onConfirm(selectedReason , motive); 
      }else{
        setMotiveError(true)
      }
      
    }else if(inativacao){
      onConfirm(motive)
    }else if(rejeicaoEst){
      if(selectedReason != ""){
        setMotiveError(false)
        onConfirm( motive); 
      }else{
        setMotiveError(true)
      }
    }else{
      onConfirm();
      handleClose(); 
    }
   
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{content}</DialogContentText>
        {rejeicaoEst && (
          <FormControl fullWidth sx={{mt:3}}>
          <TextField
            id="motivo"
            sx={{ width: "100%", mt: 1 }}
            label={'Razão da Rejeição'}
            multiline
            minRows={4}
            value={motive}
            onChange={(e) => {
              setMotive(e.target.value)
            }}
            
          />
          
        </FormControl>
        )}
        {rejeicao && (
          <FormControl fullWidth sx={{mt:3}}>
            <InputLabel id="select-label">Razão da Rejeição</InputLabel>
            <Select
            error={motiveError}
              required = {true}
              labelId="select-label"
              value={selectedReason}
              onChange={handleSelectChange}
              helperText={
                motiveError &&
                `O campo razão da rejeição é de preenchimento obrigatório`
              }
            >
              <MenuItem value={"Registo comercial inválido"}>
                Registo comercial inválido
              </MenuItem>
              <MenuItem value={"Declaração mandatada inválida"}>
                Declaração mandatada inválida
              </MenuItem>
              <MenuItem value={"Ambos documentos inválidos"}>
                Ambos documentos inválidos
              </MenuItem>
              
            </Select>
            <TextField
              id="motivo"
              sx={{ width: "100%", mt: 1 }}
              label={'Escreva aqui as suas observações...'}
              multiline
              minRows={4}
              value={motive}
              onChange={(e) => {
                setMotive(e.target.value)
              }}
              
            />
            
          </FormControl>
        )}
        {inativacao && (
          <FormControl fullWidth sx={{mt:3}}>
              <TextField
                id="motivo"
                sx={{ width: "100%", mt: 1 }}
                label={'Razão da inativação'}
                multiline
                minRows={4}
                value={motive}
                onChange={(e) => {
                  setMotive(e.target.value)
                }}
              />      
          </FormControl>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>{cancelButtonTitle}</Button>
        <Button onClick={handleConfirmClick}>{confirmButtonTitle}</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;

ConfirmDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  content: PropTypes.any,
  cancelButtonTitle: PropTypes.string.isRequired,
  confirmButtonTitle: PropTypes.string.isRequired,
  rejeicao: PropTypes.bool,
  onConfirm: PropTypes.func.isRequired,
};